import React, { useEffect, useState } from "react";
import "./noreba.css";

function Noreba() {
    const [lista, setLista] = useState([]);
    const [error, setError] = useState("");

    // Modal Subir
    const [showUp, setShowUp] = useState(false);
    const [upNombre, setUpNombre] = useState("");
    const [upFecha, setUpFecha] = useState(() => {
        const d = new Date();
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    });
    const [upFile, setUpFile] = useState(null);
    const [subiendo, setSubiendo] = useState(false);

    // Modal Confirmar eliminación
    const [confirmDel, setConfirmDel] = useState(null);

    const cargarLista = async () => {
        try {
            setError("");
            const r = await fetch("/api/noreba");
            if (!r.ok) throw new Error(await r.text());
            const data = await r.json();
            setLista(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(e.message || "No se pudo cargar la lista");
        }
    };

    useEffect(() => {
        cargarLista();
    }, []);

    const abrirModalSubir = () => {
        setUpNombre("");
        setUpFecha(() => {
            const d = new Date();
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        });
        setUpFile(null);
        setShowUp(true);
    };

    const cerrarModalSubir = () => {
        if (subiendo) return;
        setShowUp(false);
    };

    const enviarSubida = async (e) => {
        e.preventDefault();
        if (!upFile) {
            setError("Selecciona un PDF");
            return;
        }
        if (!upNombre.trim()) {
            setError("Escribe un nombre de documento");
            return;
        }
        const fd = new FormData();
        fd.append("pdf", upFile);
        fd.append("nombre", upNombre.trim());
        if (upFecha) fd.append("fecha", upFecha);

        try {
            setSubiendo(true);
            setError("");
            const r = await fetch("/api/noreba", { method: "POST", body: fd });
            if (!r.ok) throw new Error(await r.text());
            setShowUp(false);
            await cargarLista();
        } catch (e) {
            setError(e.message || "No se pudo subir el PDF");
        } finally {
            setSubiendo(false);
        }
    };

    const descargar = async (item) => {
        try {
            const r = await fetch(`/api/noreba/${item._id}?download=1`);
            if (!r.ok) throw new Error(await r.text());
            const blob = await r.blob();
            const url = window.URL.createObjectURL(blob);
            const nombre =
                (item.nombre && `${item.nombre}.pdf`) ||
                item.filename ||
                `noreba-${item._id}.pdf`;
            const a = document.createElement("a");
            a.href = url;
            a.download = nombre.replace(/\s+/g, "_");
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            setError(e.message || "No se pudo descargar el archivo");
        }
    };

    const eliminarConfirmado = async () => {
        if (!confirmDel) return;
        try {
            const r = await fetch(`/api/noreba/${confirmDel._id}`, { method: "DELETE" });
            if (!r.ok) throw new Error(await r.text());
            setConfirmDel(null);
            await cargarLista();
        } catch (e) {
            setError(e.message || "No se pudo eliminar");
        }
    };

    const formatFecha = (v) => {
        if (!v) return "";
        const d = new Date(v);
        if (Number.isNaN(d.getTime())) return String(v);
        return d.toLocaleDateString();
    };

    return (
        <div className="noreba-wrap">
            <header className="noreba-header">
                <h1>Noreba</h1>
                
            </header>

            {error && <div className="noreba-error">{error}</div>}

            <section className="noreba-list">
                {lista.length === 0 && <div className="noreba-empty">No hay documentos</div>}
                {lista.map((it) => (
                    <article key={it._id} className="noreba-item">
                        <div className="info">
                            <div className="title">{it.nombre || it.mostrar || it.filename}</div>
                            <div className="meta">
                                <span>{(it.length / 1024).toFixed(1)} KB</span>
                                <span>•</span>
                                <span>{formatFecha(it.fecha || it.uploadDate)}</span>
                            </div>
                        </div>
                        <div className="actions">
                            <button className="btn-view" onClick={() => descargar(it)}>
                                Descargar
                            </button>                            
                        </div>
                    </article>
                ))}
            </section>            
        </div>
    );
}

export default Noreba;
